export const wayaSummaryCard = [
  {
    title: "TOTAL INITIATED DISPUTE",
    objKeyRepr: "initiatedDispute",
  },
  {
    title: "TOTAL OPEN DISPUTE",
    objKeyRepr: "openDispute",
  },
  {
    title: "TOTAL CLOSED DISPUTE",
    objKeyRepr: "closedDispute",
  },
];

export const wayaMerchantSummaryCard = [
  {
    title: "TOTAL INITIATED DISPUTE",
    objKeyRepr: "initiatedDispute",
  },
  {
    title: "TOTAL OPEN DISPUTE",
    objKeyRepr: "openDispute",
  },
  {
    title: "TOTAL RESOLVED DISPUTE",
    objKeyRepr: "closedDispute",
  },
];


export const wayaDataKeysAndRepr = [
  { objKey: "disputeStatus", repr: "Status" },
  { objKey: "disputeType", repr: "Dispute Type" },
  { objKey: "transaction", repr: "Transaction" },
  { objKey: "customerEmail", repr: "Customer" },
  { objKey: "dateCreated", repr: "Date Created" },
  { objKey: "dueWhen", repr: "Due date" },
  { objKey: "action", repr: "Action" },
];

export const wayaMerchantDataKeysAndRepr = [
  { objKey: "id", repr: "Dispute ID" },
  { objKey: "disputeType", repr: "Dispute Type" },
  { objKey: "disputeAmount", repr: "Transaction" },
  { objKey: "merchantEmail", repr: "Merchant" },
  { objKey: "dateCreated", repr: "Date Created" },
  { objKey: "dueWhen", repr: "Due date" },
  { objKey: "disputeStatus", repr: "Status" },
  { objKey: "action", repr: "Action" },
];
